class AmpLocale {

    constructor() {
        this.mainDictionary = {};
        this.currentLanguageDictionary = {};
        this.currentLanguage = 'EN';
    }

    setDictionary(dictionary) {
        if (!dictionary) throw new Error('AmpLocale. requires a dictionary, dictionary:json');

        this.mainDictionary = dictionary;
    }

    addDictionary(dictionary) {
        if (!dictionary) throw new Error('AmpLocale. requires a dictionary, dictionary:json');

        this.mainDictionary = this._mergeDictionary(this.mainDictionary, dictionary);
        this.setLanguage(this.currentLanguage);
    }

    setLanguage(language) {
        if (!language) throw new Error('AmpLocale. requires a language, language:string');
        if (!this.mainDictionary[language]) throw new Error(`AmpLocale. dictionary does not contain language "${language}"`);

        this.currentLanguage = language;
        this.currentLanguageDictionary = this.mainDictionary[language];
    }

    getLanguage() {
        return this.currentLanguage;
    }

    translate(path, values) {
        if (!path) throw new Error('AmpLocale. invalid dictionary path, path:string');

        return this._getText(path, values);
    }

    translateForLanguage(path, language, values) {
        if (!path) throw new Error('AmpLocale. invalid dictionary path, path:string');
        if (!language) throw new Error('AmpLocale. requires a language, language:string');

        const _currentLanguage = this.currentLanguage;
        this.setLanguage(language);

        const text = this._getText(path, values);

        this.setLanguage(_currentLanguage);

        return text;
    }

    _getText(path, values) {
        let text = this._resolve(this.currentLanguageDictionary, path);

        if (values) {
            for (let key in values) {
                var exp = new RegExp('{' + key + '}', 'g');
                text = text.replace(exp, values[key]);
            }
        }

        return text;
    }

    _resolve(dictionary, path) {
        const text = path.split('.').reduce((prev, curr) => {
            return prev ? prev[curr] : undefined;
        }, dictionary || self);

        return text ? text : path;
    }

    _mergeDictionary(destination, source) {

        for (let language in source) {
            destination[language] = this._mergeLanguage(destination[language], source[language]);
        }

        return destination;
    }

    _mergeLanguage(destination, source) {

        for (let entry in source) {

            if (!destination[entry]) {
                destination[entry] = source[entry];
            } else if (typeof destination[entry] === 'object' && typeof source[entry] === 'object') {
                destination[entry] = this._mergeLanguage(destination[entry], source[entry]);
            } else {
                throw new Error(`AmpLocale. dictionary already contains "${entry}" key.`);
            }
        }

        return destination;
    }
};

export default AmpLocale;

//# sourceMappingURL=amp-locale-core.js.map